import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { RestService } from './rest.service';
import { RouteService } from './route.service';
import { ApplicationStateService } from './application-state.service';
import { OfflineCheck } from '../models/offline-check';
import axios from 'axios';
import { CommunicationService } from './communication.service';

@Injectable({
    providedIn: 'root'
})
export class OfflineModeService {

    check: OfflineCheck;
    private cancelTokens: Array<any> = [];
    private runsRequest = false;

    constructor(private restService: RestService,
                private routeService: RouteService,
                private applicationStateService: ApplicationStateService,
                private communicationService: CommunicationService) {
    }

    /**
     * Creates an offline version and stores the id of the version.
     */
    async getOfflineVersion(): Promise<any> {
        this.check = new OfflineCheck();

        const route = this.routeService.getRelativeRoute(
            environment.endpointUrls.offlineModeCreate,
            {
                bookId: this.applicationStateService.bookId
            }
        );

        this.cancelRequests();
        const source = axios.CancelToken.source();
        this.cancelTokens.push(source);

        try {
            const result = await axios.post(
                route,
                { withCredentials: true },
                { cancelToken: source.token }
            );

            this.check.downloadId = result.data.identifier;
        } catch (error) {
            this.check = undefined;
        }
    }

    /**
     * Gets the progress of the latest created offline version.
     */
    updateProgress(): void {
        if (!this.check || !this.check.downloadId || this.runsRequest) {
            return;
        }

        const route = this.routeService.getRelativeRoute(environment.endpointUrls.offlineModeCheck,
            {
                identifier: this.check.downloadId,
                bookId: this.applicationStateService.bookId
            });

        this.runsRequest = true;
        this.restService.get(route, {}).then(result => {
            if (this.check && this.check.downloadId > 0) {
                this.check.available = result.available;
                this.check.url = result.url;
                this.runsRequest = false;

                if (this.check.available) {
                    this.communicationService.announceOfflineVersionCreated();
                }
            }

        });
    }

    /**
     *
     * @returns {OfflineCheck}
     */
    getCheck(): OfflineCheck {
        return this.check;
    }

    cancelRequests(): void {
        this.cancelTokens.forEach(ele => {
            if (ele) {
                ele.cancel();
            }
        });

        this.cancelTokens = [];
    }

}
